import type { FaireProductEntity } from "../../entity_types/product";

export const p_q6p497t: FaireProductEntity = {
  token: "p_q6p497t",
  type: "product",
  name: "Tepoztl\u00e1n Candle",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/537ef45e477c04975db20750e65f4efd9ccdea2b4dbf2a2115481367c879c4ad.webp",
  priceDollars: 28,
  description: "Tepoztl\u00e1n candle - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "candle", "latinx"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.7,
  dimensions: {
    width: 3,
    height: 4,
    depth: 3,
  },
  inStock: true,
};
